const Dashboard = resolve => {
    require.ensure(["../components/pages/dashboard/Dashboard.vue"], () => {
        resolve(require("../components/pages/dashboard/Dashboard.vue"))
    })
}
const Settings = resolve => {
    require.ensure(["../components/pages/settings/Edit.vue"], () => {
        resolve(require("../components/pages/settings/Edit.vue"))
    })
}
const Reports = resolve => {
    require.ensure(["../components/pages/reports/View.vue"], () => {
        resolve(require("../components/pages/reports/View.vue"))
    })
}
const EngagementReport = resolve => {
    require.ensure(["../components/pages/reports/Engagement.vue"], () => {
        resolve(require("../components/pages/reports/Engagement.vue"))
    })
}
const UserMembers = resolve => {
    require.ensure(["../components/pages/user/List.vue"], () => {
        resolve(require("../components/pages/user/List.vue"))
    })
}
const UserMember = resolve => {
    require.ensure(["../components/pages/user/Edit.vue"], () => {
        resolve(require("../components/pages/user/Edit.vue"))
    })
}
const Firms = resolve => {
    require.ensure(["../components/pages/firm/List.vue"], () => {
        resolve(require("../components/pages/firm/List.vue"))
    })
}
const Firm = resolve => {
    require.ensure(["../components/pages/firm/Edit.vue"], () => {
        resolve(require("../components/pages/firm/Edit.vue"))
    })
}
const Contacts = resolve => {
    require.ensure(["../components/pages/contact/List.vue"], () => {
        resolve(require("../components/pages/contact/List.vue"))
    })
}
const Contact = resolve => {
    require.ensure(["../components/pages/contact/Edit.vue"], () => {
        resolve(require("../components/pages/contact/Edit.vue"))
    })
}
const ProjectRequests = resolve => {
    require.ensure(["../components/pages/project_request/List.vue"], () => {
        resolve(require("../components/pages/project_request/List.vue"))
    })
}
const ProjectRequest = resolve => {
    require.ensure(["../components/pages/project_request/Edit.vue"], () => {
        resolve(require("../components/pages/project_request/Edit.vue"))
    })
}
const Projects = resolve => {
    require.ensure(["../components/pages/project/List.vue"], () => {
        resolve(require("../components/pages/project/List.vue"))
    })
}
const Project = resolve => {
    require.ensure(["../components/pages/project/Edit.vue"], () => {
        resolve(require("../components/pages/project/Edit.vue"))
    })
}

export default [
    { path: "/", name: "home", component: Dashboard, meta: { login_required: true } },
    { path: "/dashboard", redirect: "/" },
    { path: "/my-profile", name: "my-profile", component: UserMember, meta: { login_required: true, search_entity: "user" } },
    { path: "/settings", name: "settings", component: Settings, meta: { admin_route: true } },
    { path: "/reports", name: "reports", component: Reports, meta: { login_required: true } },
    { path: "/engagement-report/:id", name: "engagement-report", component: EngagementReport, meta: { login_required: true } },

    { path: "/user", name: "user.list", component: UserMembers, meta: { login_required: true, search_entity: "user" } },
    { path: "/user/:id", name: "user.edit", component: UserMember, meta: { login_required: true, search_entity: "user" } },

    { path: "/firm", name: "firm.list", component: Firms, meta: { login_required: true, search_entity: "firm" } },
    { path: "/firm/:id", name: "firm.edit", component: Firm, meta: { login_required: true, search_entity: "firm" } },

    { path: "/project_request", name: "project_request.list", component: ProjectRequests, meta: { login_required: true, search_entity: "project_request" } },
    { path: "/project_request/:id", name: "project_request.edit", component: ProjectRequest, meta: { login_required: true, search_entity: "project_request" } },

    { path: "/prospective_project", name: "prospective_project.list", component: Projects, props: { prospective: true }, meta: { login_required: true, search_entity: "prospective_project" } },
    { path: "/project", name: "project.list", component: Projects, props: { prospective: false }, meta: { login_required: true, search_entity: "project" } },
    { path: "/prospective_project/:id", name: "prospective_project.edit", component: Project, meta: { login_required: true, search_entity: "prospective_project" } },
    { path: "/project/:id", name: "project.edit", component: Project, meta: { login_required: true, search_entity: "project" } },

    { path: "/contact", name: "contact.list", component: Contacts, meta: { login_required: true, search_entity: "contact" } },
    { path: "/contact/:id", name: "contact.edit", component: Contact, meta: { login_required: true, search_entity: "contact" } }
]
